import React, { useEffect } from "react";
import {useDispatch, useSelector} from 'react-redux';

import {
    Select,
} from 'antd';

import * as T from 'utils/types';
import {rsrFilterThunks} from "./RsrFilterBlockSlice";
import searchPageUserInputS from "features/content/search_page/UserInputsSlice";
import SDGSelector from "./SDGSelector";

const {Option} = Select;

// researcher filter block
export default () => {
    const dispatch = useDispatch();

    const {
        searchInput,
        keywordType,
        facultyID, 
        departmentID,
        rsrSpecific:{
            acceptingGraduateStudentChecked,
            C3IChecked,
            SDGs
        },
    } = useSelector((state: T.RootState) => state.searchPgUserInputs)


    useEffect(()=>{
        dispatch( 
            rsrFilterThunks.rFcltDeptStat({
                searchInput, keywordType, acceptingGraduateStudentChecked, C3IChecked,
                SDGs
            }) 
        );
    },[
        searchInput, keywordType, acceptingGraduateStudentChecked, C3IChecked,
        SDGs, dispatch
    ])

    useEffect(()=>{
        dispatch( 
            rsrFilterThunks.rSDGStat({
                searchInput, keywordType, acceptingGraduateStudentChecked, C3IChecked,
                facultyID, departmentID
            }) 
        );
    },[
        searchInput, keywordType, acceptingGraduateStudentChecked, C3IChecked,
        facultyID, departmentID, dispatch
    ])




    const {
        fclts,
        depts
    } = useSelector((state: T.RootState) => state.fcltDept_static);

    const {
        fcltDeptStat:{fclts: fclts_stat, depts: depts_stat, total: total_stat},
        status,
    } = useSelector((state: T.RootState) => state.rsrFilter);



    let fcltOptions = fclts_stat.map(x=><Option
        className="sub-heading-font"
        value={x.id} 
        key={x.id}
    >
        {`${fclts[x.id].name} (${x.cnt})`}
    </Option>);

    fcltOptions = [
        <Option
            className="sub-heading-font"
            value={-1}
            key={-1}
        >
            { "All Faculties" + (
                total_stat>=0 ? ` (${total_stat})` : ''
            )}
        </Option>,
        ...fcltOptions
    ]




    // we can not sum up the depts cnt directly 
    // because a reseacher may exist in two departments simultaneously
    const total_Dept = facultyID === -1 ? 
        total_stat : 
        fclts_stat.find(x=>x.id===facultyID)?.cnt;

    // console.log(total_Dept);

    let deptOptions = depts_stat.filter( d => facultyID===-1 || depts[d.id].facultyID===facultyID).map(d=><Option
        className="sub-heading-font"
        value={d.id} 
        key={d.id}
    >
        {`${depts[d.id].name} (${d.cnt})`}
    </Option>);

    deptOptions = [
        <Option
            className="sub-heading-font"
            value={-1}
            key={-1}
        >
            {'All Departments' + (
                (total_Dept!==undefined&&total_Dept>=0) ? ` (${total_Dept})` : ''
            )}
        </Option>,
        ...deptOptions
    ]



    return <>
                <Select
                    className="sub-heading-font full-width"
                    value={facultyID}
                    style={{ marginBottom: 8 }}
                    onChange={ value => {
                        dispatch(searchPageUserInputS.actions.setFacultyID(value));
                    }}
                    loading={status==="loading"}
                    disabled={status==="loading"}
                    showSearch={true}
                    filterOption={ (input, option) => (option !== undefined) &&
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    { fcltOptions }
                </Select>
                <Select
                    className="sub-heading-font full-width"
                    value={departmentID}
                    style={{ marginBottom: 8 }}
                    onChange={(value) => {
                        dispatch(
                            searchPageUserInputS.actions.setDepartmentID({
                                deptID: value, 
                                fcltID: value!==-1?depts[value].facultyID:-1
                            })
                        );
                    }}
                    loading={status==="loading"}
                    disabled={status==="loading"}
                    showSearch={true}
                    filterOption={(input, option) => (option !== undefined) &&
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    { deptOptions }
                </Select>
                <SDGSelector/>
    </>;
}

